import { Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss']
})
export class InfoPanelComponent implements OnInit {

  isCopied1: boolean = false;
  isCopied2: boolean = false;

  loading = false;
  productForm = {};
  preCheckForm = {};
  JSON: any = JSON;
  user_id = { 'user_id': this.dataService.userDetails['user_id'] };
  transactionsHistory = [];
  unreadCount: number = 0;
  @Input() isProduct: boolean;
  isPositiveResponse: boolean;
  // verifyProductAcodion = false;
  // varifyProductCheck = false;
  // showIcon = false;
  externalInfo = {};
  showMessage = false;
  currentEan = '';
  modalRef: NgbModalRef;
  closeResult: any;
  hasProductInfo = false;
  correctCouponForm = false;
  varifyProductIcon = false;
  unknownProduct = false;
  contentMsgProduct = false;
  showMsg = true;
  errorProduct = false;
  varifyProductCheck = false;
  couponMsg = '';
  activeId: string;
  externalInfoMsg = '';

  @Input() productArray;
  @Input() current_state;

  currentDate = Date.now();

  @ViewChild('productDetailModal') productDetailModal;
  @ViewChild('reviewModal') reviewModal;

  @Output() showLoader = new EventEmitter<boolean>();

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService,
    private modalService: NgbModal,
    private logService: LogService
  ) { }

  ngOnInit() {
    this.dataService.selectedCountryName = "";
  }

  ngOnChanges() {
    this.getProductData();
  }

  closeModal() {
    this.modalRef.close();
  }

  open() {
    this.modalRef = this.modalService.open(ElementRef);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getProductData() {
    // this.logService.printLog("", this.productArray);
    // this.logService.printLog("GetProductData executed", "");
    for (let i in this.productArray) {
      if (this.productArray[i]['response_type'] == "Duplicate") {
        this.productArray[i].showMsg = false;
        this.productArray[i].errorProduct = true;
        this.productArray[i].varifyProductCheck = true;
        if (this.productArray[i].hasOwnProperty('product_info')) {
          this.productArray[i].hasProductInfo = true;
        } else {
          this.productArray[i].hasProductInfo = false;
        }
      } else if (this.productArray[i]['response_type'] == "Unknown" || this.productArray[i]['response_type'] == "Uknown") {
        this.productArray[i].unknownProduct = true;
        this.productArray[i].isProduct = true;
        this.productArray[i].contentMsgProduct = true;
        if (this.productArray[i].hasOwnProperty('product_info')) {
          this.productArray[i].hasProductInfo = true;
        } else {
          this.productArray[i].hasProductInfo = false;
        }
      } else if (this.productArray[i]['response_type'] == "Blacklist") {
        this.productArray[i].varifyProductCheck = true;
        this.productArray[i].errorProduct = true;
        if (this.productArray[i].hasOwnProperty('product_info')) {
          this.productArray[i].hasProductInfo = true;
        } else {
          this.productArray[i].hasProductInfo = false;
        }
      } else if (this.productArray[i]['response_type'] == "Locked" || this.productArray[i]['response_type'] == "Not Yet For Sale") {
        this.productArray[i].varifyProductCheck = true;
        this.productArray[i].errorProduct = true;
        if (this.productArray[i].hasOwnProperty('product_info')) {
          this.productArray[i].hasProductInfo = true;
        } else {
          this.productArray[i].hasProductInfo = false;
        }
      } else if (this.productArray[i]["message"] == "Coupon not found" && this.current_state != "verify-product") {
        this.productArray[i].varifyProductCheck = false;
        this.productArray[i].couponIncorrect = false;
        this.productArray[i]["code"] = this.productArray[i]["coupon_code"];
        this.productArray[i].message = "This coupon is not ready for redemption yet. Please check with the issuer or mpedigree through the feedback page";
        if (this.productArray[i].hasOwnProperty('product_info')) {
          this.productArray[i].hasProductInfo = true;
        } else {
          this.productArray[i].hasProduvarifyProductCheckctInfo = false;
        }
      }
      else {
        this.productArray[i].contentMsgProduct = false;
        this.productArray[i].varifyProductCheck = true;
        this.productArray[i].couponIncorrect = true;
        this.productArray[i].message = this.productArray[i]["message"];
      }

      if (this.current_state === 'transaction-history') {
        this.activeId = 'one' + this.productArray[i];
      } else {
        this.activeId = 'activeId';
      }
    }
  }
  externalDb(transaction_id, ean, index) {
    if (localStorage.getItem('user') !== null) {
      this.externalInfo['user_id'] = this.dataService.userDetails['user_id'];
      this.externalInfo['transaction_id'] = transaction_id;
      this.externalInfo['code'] = ean;
      this.externalInfo['type'] = 'ean';
      // this.logService.printLog("external user id -", this.externalInfo);
      this.showLoader.emit(true);
      this.loading = true;
      this.apiService.externalInfo(this.externalInfo, (response) => {
        this.loading = false;
        // this.logService.printLog("externalDB response -", response);
        // this.logService.printLog("message -", response.message);
        // this.externalInfo = response;
        // this.productArray[index].externalInfoMsg = this.externalInfo['message'];
        // this.externalInfoMsg = this.externalInfo['message'];
        this.productArray[index].touch_externalDB = true;
        this.productArray[index].touch_externalDB_response = {
          "message": response['message']
        };
        this.socialShare(index);
        this.productDetailModal.open();
        this.productArray[index].contentMsgProduct = false;
        if (response.respone == "ok") {
          this.showMessage = true;
        } else {
          this.showMessage = false;
        }
        this.showLoader.emit(false);
      });
    } else {
      this.frontEndService.sweetAlert("Info", "Please login/signup to view this", "info");
    }

  }

  readTransaction(transaction_id, i, state) {
    if ((!this.productArray[i].read && state) || !state) {
      const readData = {
        'user_id': this.dataService.userDetails['user_id'],
        'transaction_id': transaction_id,
        'read': state
      };
      this.apiService.readTransactions(readData, (response) => {
        if (response.response === "ok") {
          this.productArray[i].read = state;
          if (!state) {

          }
        }
      });
    }
  }

  checkLogin(isReview = false) {
    if (localStorage.getItem('user') !== null) {
      if (isReview) {
        this.reviewModal.open();
      }
    } else {
      this.frontEndService.sweetAlert("Info", "Please login/signup to view this", "info");
    }
  }
  socialShare(index) {
    this.productArray[index].contentMsgProduct = false;
    this.productArray[index].varifyProductIcon = true;
  }
  clipboardCopy() {
    if (localStorage.getItem('user') !== null) {
      this.frontEndService.addToast("Success", "Text copied to clipboard", "success");
    }
  }
  reviewContent(event) {
    // console.log("event", event);
    this.productArray[event.index].save_ratings = true;
    this.productArray[event.index].save_ratings_request = event.response;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/info-panel/info-panel.component.ts